import React from "react";
import { Form, InputNumber } from "antd";

export default function MainFeaturesSection() {
  return (
    <>
      <Form.Item name="maxAmount" label="Зээлийн дээд хэмжээ (₮)">
        <InputNumber
          style={{ width: "100%" }}
          min={0}
          formatter={(v) => `${v}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
          parser={(v) => v.replace(/,/g, "")}
          placeholder="50,000,000"
        />
      </Form.Item>

      <Form.Item label="Зээлийн хугацаа (сар)">
        <div style={{ display: "flex", gap: 8 }}>
          <Form.Item name="minDurationMonths" noStyle>
            <InputNumber
              style={{ width: "100%" }}
              min={1}
              placeholder="Хамгийн бага"
            />
          </Form.Item>
          <span style={{ lineHeight: "32px", color: "#999" }}>–</span>
          <Form.Item name="maxDurationMonths" noStyle>
            <InputNumber
              style={{ width: "100%" }}
              min={1}
              placeholder="Хамгийн их"
            />
          </Form.Item>
        </div>
      </Form.Item>

      <Form.Item label="Сарын хүү (%)">
        <div style={{ display: "flex", gap: 8 }}>
          <Form.Item name="minMonthlyInterest" noStyle>
            <InputNumber
              style={{ width: "100%" }}
              min={0}
              step={0.1}
              placeholder="Хамгийн бага"
            />
          </Form.Item>
          <span style={{ lineHeight: "32px", color: "#999" }}>–</span>
          <Form.Item name="maxMonthlyInterest" noStyle>
            <InputNumber
              style={{ width: "100%" }}
              min={0}
              step={0.1}
              placeholder="Хамгийн их"
            />
          </Form.Item>
        </div>
      </Form.Item>
    </>
  );
}
